import http from '../utils/http';

/**
 * 请求地址
 * http://10.200.140.52:6066/ckips
 *
 * @param {obj} params
 * @returns Promise
 */

//请求部门列表
export function getDepartment(params) {
    return http.post('/department/list', params, {

    })
}
//请求门店列表
export function getStore(params) {
    return http.post('/store/list', params, {

    })
}

//新增门店

export function addStore(params) {
    return http.post('/store/createStore', params, {

    })
}

//编辑门店
export function editStore(params) {
    return http.post('/store/updateStore', params, {

    })
}

//修改门店状态
/**
 * @parameter status:0启用，1禁用
 * @parameter storeId
 * @parameter
*/

export function updateStatus(params) {
    return http.post('/store/updateStatus', params, {

    })
}

//删除门店

export function deleteStore(params) {
    return http.post('/store/deleteStore', params, {

    })
}

/**
 * 导出门店excel
 * @param {*} params
 */
export  function exportStoreExcel(config={}) {
    return http.get('/store/exportStoreExcel',{
        ...config
    })
}
